import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useMedia } from "../contexts/MediaContext";

const Breadcrumbs = ({ breadcrumbs, onResizeStart }) => {
  // デバイス判定
  const [isMobile, setIsMobile] = useState(false);

  // MediaContextから安全にisMediaOpenを取得
  let isMediaOpen = false;
  try {
    const mediaContext = useMedia();
    isMediaOpen = mediaContext?.isMediaOpen || false;
  } catch (error) {
    // MediaProviderが存在しない場合（LessonEditPage等）はfalseとして扱う
    console.warn(
      "MediaContext not available in Breadcrumbs - this is normal for pages without MediaProvider"
    );
  }

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <ul className="break">
      {breadcrumbs.map((breadcrumb, i) => {
        return (
          <li key={i}>
            <Link to={breadcrumb.path}>{breadcrumb.title}</Link>
          </li>
        );
      })}
      <li className="resize-handle-breadcrumb">
        {onResizeStart && !isMobile && !isMediaOpen && (
          <div
            className="resize-icon"
            onMouseDown={(e) => onResizeStart(e, "horizontal")}
            style={{
              cursor: "ew-resize",
              padding: "8px 12px",
              fontSize: "20px",
              color: "#ffffff",
              userSelect: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: "40px",
              height: "32px",
              borderRadius: "6px",
              transition: "all 0.2s",
              border: "1px solid transparent",
            }}
            title="編集エリアの幅を調整"
          >
            <i class="fa-thin fa-arrows-up-down"></i>
          </div>
        )}
      </li>
    </ul>
  );
};

export default React.memo(Breadcrumbs);
